import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const AlternativePaywall = ({ isOpen, onClose, onUpgrade }) => {
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="alt-paywall"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
          onClick={onClose}
        >
          {/* Modal */}
          <motion.div
            key="alt-paywall-card"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            className="relative bg-stone-50 rounded-2xl max-w-sm w-full mx-4 overflow-hidden border border-stone-200 font-manrope"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-stone-200">
              <h2 className="text-xl font-serif font-medium text-stone-900">
                {t('dashboard.alternativePaywall.title')}
              </h2>
              <button
                onClick={onClose}
                className="text-sm text-stone-600 hover:text-stone-800 transition-colors"
              >
                {t('dashboard.premiumPrecision.close') || 'Non ora'}
              </button>
            </div>

            <button
              type="button"
              onClick={onClose}
              aria-label={t('dashboard.premiumPrecision.close') || 'Close'}
              className="absolute top-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-stone-700 shadow-sm ring-1 ring-black/5 hover:bg-white hover:text-stone-900 transition-colors"
            >
              <X className="h-4 w-4" />
            </button>

            {/* Content */}
            <div className="p-6">
              <p className="text-stone-600 text-sm leading-relaxed mb-8">
                {t('dashboard.alternativePaywall.description')}
              </p>

              {/* Buttons */}
              <div className="space-y-4">
                <button
                  onClick={onUpgrade}
                  className="w-full h-12 rounded-none bg-[#3284f1] text-white font-medium transition-all"
                >
                  {t('dashboard.alternativePaywall.cta')}
                </button>

                <button
                  onClick={onClose}
                  className="w-full text-sm text-stone-600 hover:text-stone-800 transition-colors"
                >
                  {t('dashboard.alternativePaywall.continue')}
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AlternativePaywall;